import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
import Modaal from "modaal";
/**
 * informed
 * @constructor
 */
class Drink {
  constructor() {
    this.init();
  }
  /**
   * サンプル
   */
  init() {
    this.golddrink1();
    this.golddrink2();  
    $(".video-alpha").modaal({type:'video'});
  }
  
  golddrink1(){
    new ScrollMagic.Scene({
      triggerElement: ".js-trigger",
      triggerHook: 0.9,
      offset: 50,
      reverse: false
    })
    .setClassToggle(".js-fade-in", "fade-in") // add class to reveal
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller)
  }
  golddrink2(){
    new ScrollMagic.Scene({
      triggerElement: ".js-trigger",
      triggerHook: 0.9,
      offset: 50,
      reverse: true
    })
    .setClassToggle(".js-fixed", "fixed") // add class to reveal
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller)
  }
};

export default Drink;
